import { SET_CARD_DETAILS, CLEAR_CARD_DETAILS } from '../actions/actionTypes';

const initialState = {
  nameOnCard: '',
  cardNumber: '',
  expirationMonth: '',
  expirationYear: '',
  cvn: '',
};

const cardDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CARD_DETAILS:
      return {
        ...state,
        ...action.payload,
      };
    case CLEAR_CARD_DETAILS:
      return initialState;
    default:
      return state;
  }
};

export default cardDetailsReducer;
